import { render } from "./icon-close.svg?vue&type=template&id=944e6482?inline"
const script = {}
script.render = render

export default script